import { useEffect, useState } from "react";
import styles from "./styles.module.css";

const IMAGES = [
  `${process.env.PUBLIC_URL || ""}/assets/images/01.png`,
  `${process.env.PUBLIC_URL || ""}/assets/images/02.png`,
  `${process.env.PUBLIC_URL || ""}/assets/images/03.png`,
  `${process.env.PUBLIC_URL || ""}/assets/images/04.png`,
  `${process.env.PUBLIC_URL || ""}/assets/images/05.png`,
  `${process.env.PUBLIC_URL || ""}/assets/images/06.png`,
];

const INTERVAL_MS = 4000;

export function ImageViewer() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % IMAGES.length);
    }, INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles.imageContainer}>
      <img src={IMAGES[currentIndex]} alt="" className={styles.image} />
    </div>
  );
}
